import {
  AiOutlineDashboard,
  AiOutlineUser,
  AiOutlinePaperClip,
  AiFillHdd,
} from "react-icons/ai";
import { FaBusinessTime, FaBlogger } from "react-icons/fa";
import { RiKakaoTalkLine } from "react-icons/ri";
import { MdFeedback } from "react-icons/md";
import { BiPodcast, BiSolidBusiness } from "react-icons/bi";
import { Outlet } from "react-router-dom";
import { Layout, Menu } from "antd";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { logoutAccess } from "../../store/stateFunctions";
const { Sider, Content } = Layout;

const InternalSidebar = () => {
  // const {
  //   token: { colorBgContainer },
  // } = theme.useToken();
  const navigate = useNavigate();

  return (
    <div>
      <div className="row banner p-3">
        <div className="col-md-2">
          <a
            className="p-2 rounded-3 border border-bottom border-2 border-dark shadow"
            data-bs-toggle="offcanvas"
            href="#offcanvasExample"
            role="button"
            aria-controls="offcanvasExample"
            id="side"
          >
            <i className="bi bi-list" />
          </a>
        </div>
        <div className="col-md-8 text-center">
          {/* <h5>Welcome To The Nashik Municipal Corporation, Nashik</h5> */}
        </div>
        <div className="col-md-2 text-end">
          <Button
            variant="contained"
            color="error"
            className=" fw-bold"
            onClick={() => logoutAccess("Internal User")}
          >
            Logout
          </Button>
        </div>
      </div>
      <ul className="nav">
        <li className="nav-item" id="sidebarm">
          <div
            className="offcanvas offcanvas-start"
            style={{ width: "20rem" }}
            tabIndex={-1}
            id="offcanvasExample"
            aria-labelledby="offcanvasExampleLabel"
          >
            <div className="offcanvas-header banner text-white ">
              <p id="size" className="fs-4">
                Internal User
              </p>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              />
            </div>
            <div className="offcanvas-body ">
              <Sider width={250} style={{ height: "100vh" }}>
                <div style={{ height: "100%" }}>
                  <Menu
                    theme="light"
                    mode="inline"
                    defaultSelectedKeys={["dashboard"]}
                    onClick={({ key }) => {
                      if (key === "signout") {
                      } else {
                        navigate(key);
                      }
                    }}
                    items={[
                      {
                        key: "internaldashboard",
                        icon: <AiOutlineDashboard className="fs-4" />,
                        label: "Dashboard",
                      },
                      {
                        key: "internalevents",
                        icon: <AiOutlineDashboard className="fs-4" />,
                        label: "Events",
                      },

                      {
                        key: "internalblogs",
                        icon: <AiFillHdd className="fs-4" />,
                        label: "Blogs",
                      },
                      {
                        key: "internalpodcast",
                        icon: <AiFillHdd className="fs-4" />,
                        label: "Podcast",
                      },
                      {
                        key: "internaltalks",
                        icon: <AiFillHdd className="fs-4" />,
                        label: "Talks",
                      },
                      {
                        key: "internalnews",
                        icon: <FaBlogger className="fs-4" />,
                        label: "News",
                      },
                      {
                        key: "internalinternships",
                        icon: <FaBlogger className="fs-4" />,
                        label: "Internships",
                      },
                      {
                        key: "internaljobs",
                        icon: <FaBlogger className="fs-4" />,
                        label: "Jobs",
                      },
                      {
                        key: "internalpolls",
                        icon: <FaBlogger className="fs-4" />,
                        label: "Polls/Survey",
                      },
                      {
                        key: "internaladdinternships",
                        icon: <FaBlogger className="fs-4" />,
                        label: "Internships",
                      },
                      {
                        key: "internaladdjobs",
                        icon: <FaBlogger className="fs-4" />,
                        label: "Jobs",
                      },
                      {
                        key: "internaladdmerchant",
                        icon: <FaBlogger className="fs-4" />,
                        label: "Add Merchants",
                      },

                      //   {
                      //     key: "Advertise With Us",
                      //     icon: <FaBusinessTime className="fs-4" />,
                      //     label: "Industry",
                      //     children: [
                      //       {
                      //         key: "totalindustryusers",
                      //         icon: <AiOutlineUser className="fs-4" />,
                      //         label: "Total Industry User",
                      //       },
                      //       {
                      //         key: "internshipsfromindustry",
                      //         icon: <AiFillHdd className="fs-4" />,
                      //         label: "Internships",
                      //       },
                      //       {
                      //         key: "newsfromindustry",
                      //         icon: <AiOutlinePaperClip className="fs-4" />,
                      //         label: "News",
                      //       },
                      //       {
                      //         key: "talksfromindustry",
                      //         icon: <RiKakaoTalkLine className="fs-4" />,
                      //         label: "Talks",
                      //       },
                      //       {
                      //         key: "jobsfromindustry",
                      //         icon: <BiSolidBusiness className="fs-4" />,
                      //         label: "Jobs",
                      //       },
                      //       {
                      //         key: "eventsfromindustry",
                      //         icon: <AiFillHdd className="fs-4" />,
                      //         label: "Events",
                      //       },
                      //       {
                      //         key: "blogsfromindustry",
                      //         icon: <FaBlogger className="fs-4" />,
                      //         label: "Blogs",
                      //       },
                      //       {
                      //         key: "podcastfromindustry",
                      //         icon: <BiPodcast className="fs-4" />,
                      //         label: "Podcasts",
                      //       },
                      //       {
                      //         key: "feedbacksfromindustryusers",
                      //         icon: <MdFeedback className="fs-4" />,
                      //         label: "Feedbacks",
                      //       },
                      //     ],
                      //   },
                      //   {
                      //     key: "merchantslist ",
                      //     icon: <FaBusinessTime className="fs-4" />,
                      //     label: "Merchants",
                      //     children: [
                      //       // {
                      //       //   key: "students",
                      //       //   icon: <AiOutlineUser className="fs-4" />,
                      //       //   label: "Total Students",
                      //       // },
                      //       {
                      //         key: "merchantslist",
                      //         icon: <AiFillHdd className="fs-4" />,
                      //         label: "Merchants Lists",
                      //       },
                      //       {
                      //         key: "totalmerchants",
                      //         icon: <AiFillHdd className="fs-4" />,
                      //         label: "Total Merchants",
                      //       },
                      //     ],
                      //   },
                      //   {
                      //     key: "",
                      //     icon: <AiFillHdd className="fs-4" />,
                      //     label: "Yuvasarthi Admin",
                      //     children: [
                      //       {
                      //         key: "postinternships",
                      //         icon: <AiFillHdd className="fs-4" />,
                      //         label: "Post Internships",
                      //       },

                      //       {
                      //         key: "postjobs",
                      //         icon: <AiFillHdd className="fs-4" />,
                      //         label: "Post Jobs",
                      //       },
                      //       {
                      //         key: "addevents",
                      //         icon: <AiFillHdd className="fs-4" />,
                      //         label: "Events",
                      //       },

                      //       {
                      //         key: "addpodcasts",
                      //         icon: <BiPodcast className="fs-4" />,
                      //         label: "Podcasts",
                      //       },
                      //       {
                      //         key: "addtalks",
                      //         icon: <RiKakaoTalkLine className="fs-4" />,
                      //         label: "Talks",
                      //       },
                      //       {
                      //         key: "addnews",
                      //         icon: <AiOutlinePaperClip className="fs-4" />,
                      //         label: "News",
                      //       },
                      //       {
                      //         key: "addblogs",
                      //         icon: <FaBlogger className="fs-4" />,
                      //         label: "Blogs",
                      //       },
                      //       {
                      //         key: "addpolls",
                      //         icon: <FaBlogger className="fs-4" />,
                      //         label: "Polls",
                      //       },
                      //       {
                      //         key: "contactentries",
                      //         icon: <FaBlogger className="fs-4" />,
                      //         label: "Contact Form Entries",
                      //       },
                      //     ],
                      //   },
                    ]}
                  />
                </div>
              </Sider>
            </div>
          </div>
        </li>
      </ul>

      {/* <Content
        style={{
          // margin: "24px 16px",
          padding: 22,
          // minHeight: 280,
        }}
      >
        <Outlet />
      </Content> */}
    </div>
  );
};

export default InternalSidebar;
